import { LocalComponent } from "~/ecs/base"

export class BoneTwistError extends LocalComponent {}
